import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const CableMarkHeaderStyled = styled(Box).attrs({
  p: { sm: '400' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
  `}
`;
export const CableMarkFromHeaderStyled = styled(Box)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[300]};
  `}
`;
export const CableMarkRowContainerStyled = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.grey[300]};
    border-top: none;
  `}
`;
export const CableMarkRowStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: 0.5px solid ${theme.colors.grey[300]};
  `}
`;
export const CableMarkFromFieldStyled = styled(Box)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[300]};
  `}
  .input-wrapper {
    border: 0;
  }
`;
export const CableMarkToFieldStyled = styled(Box)`
  .input-wrapper {
    border: 0;
  }
`;

export const OptionContainerStyled = styled(Box).attrs({
  ml: { sm: '200' },
})`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
